/* tslint:disable */
/* eslint-disable */
/**
 * Control Online API
 * Control Online API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface AdminCourseCreateRequestDto
 */
export interface AdminCourseCreateRequestDto {
  /**
   *
   * @type {string}
   * @memberof AdminCourseCreateRequestDto
   */
  name: string;
}

export function AdminCourseCreateRequestDtoFromJSON(json: any): AdminCourseCreateRequestDto {
  return AdminCourseCreateRequestDtoFromJSONTyped(json, false);
}

export function AdminCourseCreateRequestDtoFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): AdminCourseCreateRequestDto {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    name: json["name"],
  };
}

export function AdminCourseCreateRequestDtoToJSON(value?: AdminCourseCreateRequestDto | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    name: value.name,
  };
}
